<h2 mat-dialog-title>{{ data.label }}</h2>

<form [formGroup]="form" (ngSubmit)="save()">
  <mat-dialog-content>
    @if (data.mode === 'single') {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ data.label }}</mat-label>

        <input matInput [matDatepicker]="picker" formControlName="value" />

        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    }

    @if (data.mode === 'range') {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ data.label }}</mat-label>

        <mat-date-range-input [rangePicker]="rangePicker">
          <input matStartDate formControlName="start" placeholder="Start date" />
          <input matEndDate formControlName="end" placeholder="End date" />
        </mat-date-range-input>

        <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #rangePicker></mat-date-range-picker>
      </mat-form-field>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="clear()">Clear</button>
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-flat-button type="submit">Save</button>
  </mat-dialog-actions>
</form>